/** Available budget request status types */
export enum BudgetRequestStatusTypeEnum {
  DRAFT = 'DRAFT',
  ON_APPROVAL = 'ON_APPROVAL',
  AGREED = 'AGREED',
  REFUSED = 'REFUSED',
}
